module.exports = __webpack_public_path__ + "static/media/train3.411e8d57.png";